import { PageProps } from './props';

export const Page = ({ children }: PageProps) => {
  return <div className="flex flex-1 flex-col">{children}</div>;
};
